import React, { useReducer } from "react"
import { UIStore } from "./stores/UIStore";
import MyButton from "./UI/button/MyButton";
import {useNavigate} from 'react-router-dom'


const ModelItem = (props) => {
    // const isDarkMode = UIStore.useState(s => s.isDarkMode);
    const router = useNavigate()
    
    return (
        <div className='model'>
            <div className='model__content'>
                <strong>{props.model.id}. {props.model.title}</strong>
                <div>
                {props.model.body}
                </div>
            {/* <div>`Mode is: {isDarkMode ? "black" : "white"}`</div> */}
                <div className='model__btns'>
                    <MyButton style={{margin: '10px'}} onClick={() => router(`/models/${props.model.id}`)}>
                        Open
                    </MyButton>
                    <MyButton onClick={() => props.remove(props.model)}>
                        Delete
                    </MyButton>
                    <MyButton style={{marginLeft: '50px'}} onClick={() => props.showZone3d(props.model.id)}>
                        Show model
                    </MyButton>
                </div>
            </div>
        </div>
    )
}

export default ModelItem

